import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchProductsSuccess,
    showProductMessage,
    onSaveProductSuccess,
    onDeleteProductSuccess,
    addFavouriteProductSuccess,
    onFetchSelectValueStreamDataSuccess,
} from 'actions/product';
import {
    fetchValueStreams,
} from 'actions/valueStream';
import {
    fetchMembers,
} from 'actions/member';
import {
    fetchBusinessUnits,
} from 'actions/businessUnit';
import {
    ON_SAVE_PRODUCT,
    FETCH_ALL_PRODUCT,
    ON_DELETE_PRODUCT,
    ADD_FAVOURITE_PRODUCT,
    ON_FETCH_SELECT_VALUESTREAM_DATA,
    ON_PRODUCT_VALUESTREAM_UPDATE,
    FETCH_PRODUCT_LOOKUP_DATA,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';
import { mapDataToSelectionData } from 'services/selectors';

const currentOrg = (state) => state.orgs.selectedOrg;
const getProductList = (state) => state.products.allProduct;
const getSelectedProduct = (state) => state.products.selectedProduct;
const getValueStreamList = (state) => state.valueStreams.allValueStream;
const getSelectedValueStreams = (state) => state.products.valueStreamSelectionList;

export function* fetchProductLookupData() {
    // const valueStreams = yield select(getValueStreamList);
    // if (Array.isArray(valueStreams) && valueStreams.length === 0) {
        // dispatch a fetch
        yield put(fetchValueStreams());
    // }
    // const members = yield select(getMemberList);
    // if (Array.isArray(members) && members.length === 0) {
    //     // dispatch a fetch
        yield put(fetchMembers());
    // }
    // const businessUnits = yield select(getBusinessUnitList);
    // if (Array.isArray(businessUnits) && businessUnits.length === 0) {
    //     // dispatch a fetch
        yield put(fetchBusinessUnits());
    // }
}

export function* fetchProducts() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedProducts = yield call(
            fetchDataRequest,
            'products',
            [ORGID_PATH_PARAM],
            [selectedOrg?.id]
        ) || [];
        yield put(fetchProductsSuccess(fetchedProducts));
    } catch (error) {
        yield put(showProductMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteProduct({ payload }) {
    try {
        // payload should be the productId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteProduct',
            'Deleting product '.concat(payload),
            [ORGID_PATH_PARAM, 'productId'],
            [selectedOrg?.id, payload]
        ) || [];
        yield put(onDeleteProductSuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showProductMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveProduct({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allProducts = yield select(getProductList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg?.id };
        }
        const savedProduct = yield call(
            addOrUpdateDataRequest,
            allProducts,
            finalPayload,
            'addProduct',
            'updateProduct',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveProductSuccess(savedProduct));
    } catch (error) {
        yield put(showProductMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteProduct({ payload }) {
    try {
        const allProducts = yield select(getProductList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allProducts.filter((entry) => entry?.id === payload?.id);

        if (filtered?.length > 0) {
            const entry = filtered[0];
            const updatedProduct = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedProduct?.starred).concat(' for product ').concat(updatedProduct?.id);
            yield call(
                updateDataRequest,
                updatedProduct,
                'updateProduct',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteProductSuccess(payload));
        }
    } catch (error) {
        yield put(showProductMessage(error.messages));
    }
}

export function* onFetchSelectValueStreamData() {
    const selectedProduct = yield select(getSelectedProduct);
    const allValueStreams = yield select(getValueStreamList);
    const selectedDrillDownItems = (Array.isArray(selectedProduct?.valueStreams)) ? selectedProduct?.valueStreams : [];
    const selections = mapDataToSelectionData(allValueStreams, selectedDrillDownItems) || null;
    yield put(onFetchSelectValueStreamDataSuccess(selections));
}

export function* onProductValueStreamUpdate() {
    try {
        // go through each  - check if entry is being added or removed and cleanup the other object being referenced
        const selectedOrg = yield select(currentOrg);
        const selectedProduct = yield select(getSelectedProduct);
        const selectedValueStreams = yield select(getSelectedValueStreams);
        const updatedDrillDownSelections = new Array();
        selectedValueStreams.forEach((selection) => {
            if (selection?.selected) {
                updatedDrillDownSelections.push(selection?.id);
            }
        });
        const updatedSelectedProduct = {
            ...selectedProduct,
            valueStreams: updatedDrillDownSelections
        };
        const auditMsg = 'Updating selected valueStream to '.concat(' for product ').concat(updatedSelectedProduct?.id);
        yield call(
            updateDataRequest,
            updatedSelectedProduct,
            'updateProduct',
            auditMsg,
            [ORGID_PATH_PARAM],
            [selectedOrg.id],
        );
        yield put(onSaveProductSuccess(updatedSelectedProduct));
    } catch (error) {
        yield put(showProductMessage(apiErrorMessageFormatter(error)));
    }
}



export function* fetchProductLookupDataSaga() {
    yield takeEvery(FETCH_PRODUCT_LOOKUP_DATA, fetchProductLookupData);
}

export function* fetchProductsSaga() {
    yield takeEvery(FETCH_ALL_PRODUCT, fetchProducts);
}

export function* saveProductSaga() {
    yield takeEvery(ON_SAVE_PRODUCT, saveProduct);
}

export function* deleteProductSaga() {
    yield takeEvery(ON_DELETE_PRODUCT, deleteProduct);
}

export function* addFavouriteProductSaga() {
    yield takeEvery(ADD_FAVOURITE_PRODUCT, addFavouriteProduct);
}

export function* onFetchSelectValueStreamDataSaga() {
    yield takeEvery(ON_FETCH_SELECT_VALUESTREAM_DATA, onFetchSelectValueStreamData);
}

export function* onProductValueStreamUpdateSaga() {
    yield takeEvery(ON_PRODUCT_VALUESTREAM_UPDATE, onProductValueStreamUpdate);
}

export default function* rootSaga() {
    yield all([
        fork(fetchProductsSaga),
        fork(saveProductSaga),
        fork(deleteProductSaga),
        fork(addFavouriteProductSaga),
        fork(onFetchSelectValueStreamDataSaga),
        fork(onProductValueStreamUpdateSaga),
        fork(fetchProductLookupDataSaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/product.js